import { GetComisionContactCenterConsultar } from "../../../reducers/comisionContactCenter";

export interface ReporteContactCenterStore
  extends GetComisionContactCenterConsultar {}

export const reporteContactCenterStore: (
  state: any
) => ReporteContactCenterStore = (state: any) => ({
  comisionContactCenterConsulta:
    state.comisionContactCenter.comisionContactCenterConsulta,
  gettingComisionContactCenter:
    state.comisionContactCenter.gettingComisionContactCenter,
  gettingComisionContactCenterError:
    state.comisionContactCenter.gettingComisionContactCenterError
});
